import { ModelRenderer, Shark, Utils } from "shark-mvc";

class ConstructionSiteRenderer extends ModelRenderer {
	constructor (model) {
		super(model);
	}

	parseModelValues (data) {
		//this.__parseModelValues(data);
		// console.log({data}, this);

		const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: 'EUR', style: 'currency' });
		this.presumedAmountLabel = formatterCurrency.format(this.model.__presumedAmount);

		this.typeLabel = this.model.type === "industrial" ? "Industriale" : (this.model.type === "outdoor" ? "Outdoor" : "N/D");

		this.statusLabel = Shark.get("constructionSiteStatusMap")[this.model.status];
		if (this.model.status === 2) {
			this.statusLabel += "<br><small>(manca chiusura fiscale)</small>";
		}
	}
}

export default ConstructionSiteRenderer;